import type { ReactNode } from 'react'
import useSlidingPill from '../useSlidingPill'
import PulsePillContext from './pulsePillContext'
import { PulsePill, PulsePillWrapper } from './styled-components'

interface PulsePillGroupProps {
  enabled: boolean
  selectedIndex: number | undefined
  disabled: boolean
  children: ReactNode
}

const PulsePillGroup = ({ enabled, selectedIndex, disabled, children }: PulsePillGroupProps) => {
  const { wrapperRef, box, animated } = useSlidingPill(enabled, selectedIndex)

  if (!enabled) return <>{children}</>

  return (
    <PulsePillContext.Provider value={selectedIndex !== undefined}>
      <PulsePillWrapper ref={wrapperRef}>
        {box && <PulsePill $box={box} $animated={animated} $disabled={disabled} />}
        {children}
      </PulsePillWrapper>
    </PulsePillContext.Provider>
  )
}

export default PulsePillGroup
